import { HTMLAttributes } from 'react';
import { escapeRegExp } from '@sib/utils';

interface GlobalSearchHighlightedTextProps
  extends HTMLAttributes<HTMLSpanElement> {
  text: string;
  searchTerm: string;
}

export const GlobalSearchHighlightedText = ({
  text,
  searchTerm,
  className,
  ...rest
}: GlobalSearchHighlightedTextProps) => {
  const trimmedSearchTerm = searchTerm.trim();

  if (!trimmedSearchTerm)
    return (
      <span className={className} {...rest}>
        {text}
      </span>
    );

  const parts = text.split(
    new RegExp(`(${escapeRegExp(trimmedSearchTerm)})`, 'gi')
  );

  return (
    <span className={className} {...rest}>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <strong key={`${part}-${index}`} className="font-semibold">
            {part}
          </strong>
        ) : (
          part
        )
      )}
    </span>
  );
};
